import { render, staticRenderFns } from "./index.vue?vue&type=template&id=16dd1121&scoped=true"
import script from "./PopularQuestion.js?vue&type=script&lang=js&external"
export * from "./PopularQuestion.js?vue&type=script&lang=js&external"
import style0 from "./styles.scss?vue&type=style&index=0&id=16dd1121&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dd1121",
  null
  
)

export default component.exports